import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MediaModule } from '../media/index';

import { DropdownDirective } from './dropdown.directive';
import { DropdownMenuDirective } from './menu.directive';
import { DropdownItemComponent } from './item.component';
import { DropdownHeaderComponent, DropdownHeaderDirective } from './header.component';
import { DropdownDividerComponent } from './divider.component';
import { DropdownTextComponent, DropdownTextDirective } from './text.component';

export { DropdownDirective } from './dropdown.directive';
export { DropdownMenuDirective } from './menu.directive';
export { DropdownItemComponent } from './item.component';
export { DropdownHeaderComponent, DropdownHeaderDirective } from './header.component';
export { DropdownDividerComponent } from './divider.component';
export { DropdownTextComponent, DropdownTextDirective } from './text.component';

@NgModule({
  declarations: [
    DropdownDirective,
    DropdownMenuDirective,
    DropdownItemComponent,
    DropdownHeaderComponent,
    DropdownHeaderDirective,
    DropdownDividerComponent,
    DropdownTextComponent,
    DropdownTextDirective
  ],
  imports: [
    CommonModule,

    MediaModule
  ],
  exports: [
    DropdownDirective,
    DropdownMenuDirective,
    DropdownItemComponent,
    DropdownHeaderComponent,
    DropdownHeaderDirective,
    DropdownDividerComponent,
    DropdownTextComponent,
    DropdownTextDirective
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class DropdownModule {}
